import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { TimeSlot } from '@checkout-v2/const';
import { ItemWrapperComponent } from '../item-wrapper';

@Component({
  selector: 'sd-time-slot-groups',
  imports: [ItemWrapperComponent],
  templateUrl: './time-slot-groups.component.html',
  styleUrl: './time-slot-groups.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TimeSlotGroupsComponent {
  readonly selectedTimeSlot = input.required<TimeSlot>();
  readonly selectedGroupName = model<string>();

  onSelectGroup(name: string): void {
    this.selectedGroupName.set(name);
  }
}
